module.exports = __webpack_public_path__ + "img/feder_pope_cdti_nuevo_h.6373eed7.png";